<template>
  <v-alert
    v-if="authStore.isImpersonating"
    type="warning"
    variant="tonal"
    density="comfortable"
    class="impersonation-banner"
    icon="mdi-account-eye"
  >
    <div class="impersonation-banner__content">
      <div>
        Viendo como <strong>{{ impersonatedName }}</strong> (solo lectura)
        <span v-if="authStore.sessionInfo?.impersonation?.adminName" class="text-caption ml-2">
          — admin: {{ authStore.sessionInfo.impersonation.adminName }}
        </span>
      </div>
      <v-btn
        color="warning"
        variant="flat"
        size="small"
        @click="onStop"
      >
        Salir
      </v-btn>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

import { useAuthStore } from '@/stores/auth'

export default defineComponent({
  name: 'ImpersonationBanner',

  setup() {
    const authStore = useAuthStore()

    const impersonatedName = computed(() => {
      return authStore.sessionInfo?.name || authStore.currentUser?.name || 'usuario'
    })

    const onStop = async () => {
      await authStore.stopImpersonation()
    }

    return {
      authStore,
      impersonatedName,
      onStop,
    }
  },
})
</script>

<style scoped>
.impersonation-banner {
  position: relative;
  z-index: 1;
  border-radius: 0;
  background: rgb(var(--v-theme-surface)) !important;
}

.impersonation-banner :deep(.v-alert__underlay) {
  opacity: 1;
  background: rgba(var(--v-theme-warning), 0.16) !important;
}

.impersonation-banner__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
</style>
